import PigletTransportApi from '@/api/piglet/pigletZsdbApi';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUpdate({dispatch}, form) {
      try {
        const response = await PigletTransportApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'piglet.notification.zsdb', {root: true});
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async createPackage({dispatch}, form) {
      try {
        const response = await PigletTransportApi.createPackage(form);
        dispatch('NOTIFY_MSG', 'piglet.notification.zsdb', {root: true});
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchTodo({dispatch}, {owner}) {
      try {
        const response = await PigletTransportApi.fetchTodo(owner);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchByPackage({dispatch}, {packageId}) {
      try {
        const response = await PigletTransportApi.fetchPackageId(packageId);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchTransports({dispatch}) {
      try {
        const response = await PigletTransportApi.fetchTransports();
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchReasons({dispatch}) {
      try {
        const response = await PigletTransportApi.fetchReasons();
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async sendPackage({dispatch}, {id}) {
      try {
        const response = await PigletTransportApi.sendPackage(id);
        dispatch('NOTIFY_MSG', 'piglet.notification.zsdb', {root: true});
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async removeMetadata({dispatch}, {id}) {
      try {
        await PigletTransportApi.removeMetadata(id);
        return Promise.resolve()
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
  }
}
